import immutableStore from 'alt-utils/lib/ImmutableUtil';
import alt from 'components/Dispatcher';
import FilterWordsActions from 'actions/triggers/FilterWordsActions';
import {List} from 'immutable';
import FilterWord from 'records/FilterWord';

/**
 * Stores topics for use with triggers.
 *
 * Contains only topics, never keywords.
 */
@immutableStore
class FilterWordsStore {
  constructor() {
    this.state = {
      filterWords: List(), // All topics in the account.
      filterWordsLoaded: false,
    };

    this.bindActions(FilterWordsActions);
  }

  fetchAllSuccess(filterWords) {
    this.setState({
      ...this.state,
      filterWords: List(filterWords.map(item => new FilterWord(item))),
      filterWordsLoaded: true,
    });
  }

  fetchAllError(response) {
    this.setState({
      ...this.state,
      filterWords: List(),
      filterWordsLoaded: true,
    });

    console.warn(response);
  }
}

export default alt.createStore(FilterWordsStore, 'FilterWordsStore');
